import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddFormFieldsComponent } from "../add-form-fields/add-form-fields.component";
import { StaffSurveyService } from "src/app/services/staff-survey/staff-survey.service";
import { AppService } from "src/app/services/app/app.service";
import { DatePipe } from "@angular/common";
import { NgxSpinner, NgxSpinnerService } from "ngx-spinner";
import { CommonService } from "src/app/services/common/common.service";
import { DateAdapter } from "@angular/material/core";
import { startDateBeforeEndDateValidator } from "src/app/model/start_end_date";
import { DeleteItemComponent } from "../../delete-item/delete-item.component";

// {
// 	q_type:"desc",  //type of question
// 	que:"",         //question
// 	q_desc:"",      //question description
// 	is_rq:"",       //Required
// 	ans:"",         // answer could be array also range also and blank also
// 	rt:""            //rating stars
// }
@Component({
  selector: "app-add-staff-survey",
  templateUrl: "./add-staff-survey.component.html",
  styleUrls: ["./add-staff-survey.component.scss"],
})
export class AddStaffSurveyComponent {
  public surveyForm!: FormGroup;
  public isSurveyDetailCompleted: boolean = false;
  public isError: boolean = false;
  public error!: String;
  public surveyArr: any[] = [
    // {
    //   q_type:"desc",
    //   que:"",
    //   q_desc:"",
    //   is_rq:"",
    //   ans:"",
    //   rt:""
    // }
  ];
  public panelOpenState = false;
  minDate = new Date();
  public selectOptionArr: any[] = ["option 1", "option 2", "option 3"];
  public currentRate = 6;
  public isEditSurvey: boolean = false;
  public opinionScaleArr: any[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddStaffSurveyComponent>,
    private dialog: MatDialog,
    private appService: AppService,
    private staffSurveyService: StaffSurveyService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private dateAdapter: DateAdapter<Date>,
  ) {
    this.dateAdapter.setLocale('en-GB');
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.surveyForm = this.fb.group({
      s_t: ["", Validators.required],
      s_desc: "",
      st_dt: [null, Validators.required],
      ed_dt: [null, Validators.required],
      active: "",
    },
    {validator: startDateBeforeEndDateValidator('st_dt','ed_dt')});
    if (this.dialogData && this.dialogData["is_edit"] == true) {
      this.isEditSurvey = true;
      this.onViewSurvey();
    }
  }
  get getControls() {
    return this.surveyForm.controls;
  }
  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + "k";
    }

    return `${value}`;
  }

  mainDrop(event: CdkDragDrop<string[]>) {
    // moveItemInArray(this.selectedCourse.sections, event.previousIndex, event.currentIndex);
    moveItemInArray(this.surveyArr, event.previousIndex, event.currentIndex);
  }
  onBack() {
    this.isSurveyDetailCompleted = false;
  }
  onClose() {
    this.dialogRef.close();
  }
  onNext() {
    if (this.surveyForm.invalid) {
      this.surveyForm.markAllAsTouched();
    } else {
      this.isSurveyDetailCompleted = true;
    }
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(
      this.surveyForm,
      controlName,
      validationType
    );
  }
  onSave() {
    let dataObj = {};
    dataObj = Object.assign(this.surveyForm.value, dataObj);
    dataObj["st_dt"] = this.datePipe.transform(
      this.surveyForm.get("st_dt")?.value,
      "yyyy-MM-dd"
    );
    dataObj["ed_dt"] = this.datePipe.transform(
      this.surveyForm.get("ed_dt")?.value,
      "yyyy-MM-dd"
    );
    dataObj["dep"] = 0;
    dataObj["manager"] = [];
    dataObj["employee"] = [];
    dataObj["survey"] = this.surveyArr;
    if(this.surveyArr.length >0){
      this.onSaveAPI(dataObj);
    }
   else{
    this.appService.showToastMessage('warning',"Please add data to save survey")
   }
  }
  onSaveAPI(dataObj) {
    if (!this.isEditSurvey) {
      this.spinner.show();
      this.staffSurveyService.add(dataObj).subscribe({
        next: (success: any) => {
          this.spinner.hide();
          if (success.status == 200) {
            this.appService.showToastMessage("success", success.msg);
            this.dialogRef.close({ data_added: true });
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
 
    else {
      dataObj["su_i"] = this.dialogData.id;
      this.spinner.show();
      this.staffSurveyService.edit(dataObj).subscribe({
        next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage("success", success.msg);
          this.dialogRef.close({ data_added: true });
        }
      },
       error: (error: any) => {
          this.commonService.handleError(error);
        },
    });
    }
  }

  onInput(value: any) {}
  onEditItem(event: Event, item: any, index) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(AddFormFieldsComponent, {
      width: "85%",
      height: "90%",
      maxWidth: "100vw",
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      disableClose: true,
      data: { ...item },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // const index = this.surveyArr.findIndex(item => item.id === updatedObject.id);
        this.surveyArr.splice(index, 1, result.data);
        //  this.surveyArr.push(result.data);
      }
    });
  }
  onCopyItem(event: Event, item: any) {
    event.stopPropagation();
    const copiedItem = { ...item };
    copiedItem["s_di"] = "";
    this.surveyArr.push(JSON.parse(JSON.stringify(copiedItem)));
  }
  onDeleteItem(event: Event, id: any) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_staff_survey_item", id: id }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.surveyArr.splice(id, 1);
      }
    });
 
  }
  onAddField() {
    const dialogRef = this.dialog.open(AddFormFieldsComponent, {
      width: "85%",
      height: "90%",
      maxWidth: "100vw",
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.surveyArr.push(result.data);
      }
    });
  }
  onEditSurvey() {}
  onViewSurvey() {
    this.staffSurveyService.view(this.dialogData.id).subscribe({
      next: (result: any) => {
        if (result.status == 200) {
          this.surveyArr = result["data"]["survey"];
          this.surveyForm.patchValue(result["data"]);
          this.surveyForm.patchValue({
            active: result["data"]["is_a"]
          });
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
}
